export default __webpack_public_path__ + "c181feded41de41ccfaf402a97a48055.jpg";